(() => {
  const clean = (element) => element.textContent.replace(/\s+/g, ' ').trim();
  const containsFAQ = (value) => {
    if (Array.isArray(value)) return value.some(containsFAQ);
    if (!value || typeof value !== 'object') return false;
    if (value['@type'] === 'FAQPage' || (Array.isArray(value['@type']) && value['@type'].includes('FAQPage'))) return true;
    return Array.isArray(value['@graph']) && value['@graph'].some(containsFAQ);
  };
  const build = () => {
    if (Array.from(document.querySelectorAll('script[type="application/ld+json"]')).some((script) => {
      try { return containsFAQ(JSON.parse(script.textContent)); } catch { return false; }
    })) return;
    const questions = [];
    const seen = new Set();
    document.querySelectorAll('.col-des').forEach((description) => {
      const heading = Array.from(description.querySelectorAll('h1, h2, h3')).find((element) => /^(frequently asked questions|faqs?)\b/i.test(clean(element)));
      if (!heading) return;
      let question = '';
      let answers = [];
      const flush = () => {
        const answer = answers.join(' ').trim();
        if (question && answer && !seen.has(question)) {
          seen.add(question);
          questions.push({ '@type': 'Question', name: question, acceptedAnswer: { '@type': 'Answer', text: answer } });
        }
      };
      for (let node = heading.nextElementSibling; node; node = node.nextElementSibling) {
        if (/^H[12]$/.test(node.tagName)) break;
        const text = clean(node);
        const bold = node.querySelector(':scope > strong:only-child, :scope > b:only-child');
        const isQuestion = /\?$/.test(text) && (/^H[34]$/.test(node.tagName) || (node.tagName === 'P' && bold && clean(bold) === text));
        if (isQuestion) {
          flush();
          question = text.replace(/^\s*\d+[.)]\s*/, '');
          answers = [];
        } else if (question && text && !node.matches('script, style, nav')) {
          if (node.matches('p') && !node.querySelector('a')) answers.push(text);
          else if (node.matches('p') && !/^\s*(browse|explore|also browse)\b/i.test(text)) {
            const prose = node.cloneNode(true);
            prose.querySelectorAll('a').forEach((link) => link.remove());
            if (clean(prose).replace(/[|·•,;:-]/g, '').trim()) answers.push(text);
          }
          else if (node.matches('ul, ol')) answers.push(text);
        }
      }
      flush();
    });
    if (!questions.length) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'expressluv-collection-faq-schema';
    script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', '@id': (document.querySelector('link[rel="canonical"]')?.href || location.href.split('?')[0]) + '#faq', mainEntity: questions });
    document.head.appendChild(script);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build, { once: true });
  else build();
})();
